import { memo } from "react";

import styles from "./NarmiDashboardTile.module.scss";
import { NarmiTile } from "./NarmiTile";

type Props = {
  tile: API.NarmiTile;
  isFixed?: boolean;
};

const NarmiDashboardTile = ({ tile, isFixed }: Props) => {
  return (
    <div className={styles["dashboard-tile-container"]}>
      <NarmiTile tile={tile} fixedHeight={isFixed ? "100%" : undefined} />
    </div>
  );
};

export default memo(NarmiDashboardTile);
